/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

/**
 * Directive based on ngIf which evaluates expressions in the context of the BulbAuthService currentUser.
 */
angular.module('bulbApp.authModule')
.directive('bulbAuth', ['$parse','BulbAuthService','ngIfDirective','AUTH', bulbAuth]);

function bulbAuth($parse, BulbAuthService, ngIfDirective, AUTH) {
  var ngIf = ngIfDirective[0];

  return {
    transclude: ngIf.transclude,
    priority: ngIf.priority,
    terminal: ngIf.terminal,
    restrict: ngIf.restrict,
    link: function(scope, element, attr) {
      var exp = $parse(attr.bulbAuth);
      attr.ngIf = function() {
        return exp(scope, {
          currentUser: BulbAuthService.currentUser,
          PERMISSIONS: AUTH.PERMISSIONS,
          ROLES: AUTH.ROLES
        });
      };
      ngIf.link.apply(ngIf, arguments);
    }
  };
}
